import { useState, useEffect } from "react";
import { useReadContract, useWatchContractEvent } from "wagmi";
import { motion, AnimatePresence } from "framer-motion";
import { Crown } from "lucide-react";
import { formatEther } from "viem";
import { polygon } from "viem/chains";
import { Link } from "react-router-dom";
import { KING_OF_HILL_ABI, KING_OF_HILL_ADDRESS } from "./contractConfig";

export const KingPreview = () => {
  const [shake, setShake] = useState(false);

  // Read contract data
  const { data: currentKing } = useReadContract({
    address: KING_OF_HILL_ADDRESS,
    abi: KING_OF_HILL_ABI,
    functionName: "currentKing",
    chainId: polygon.id,
  });

  const { data: currentStake } = useReadContract({
    address: KING_OF_HILL_ADDRESS,
    abi: KING_OF_HILL_ABI,
    functionName: "currentStake",
    chainId: polygon.id,
  });

  // Watch for contract events
  useWatchContractEvent({
    address: KING_OF_HILL_ADDRESS,
    abi: KING_OF_HILL_ABI,
    eventName: 'KingClaimed',
    onLogs() {
      // Trigger shake animation
      setShake(true);
      setTimeout(() => setShake(false), 820); // Animation duration + small buffer
    },
  });

  const formatAddress = (address: string) => {
    return `${address?.slice(0, 6)}...${address?.slice(-4)}`;
  };

  return (
    <Link to="/king-of-the-bots">
      <motion.div
        animate={shake ? {
          x: [-10, 10, -10, 10, -5, 5, -2, 2, 0],
        } : {}}
        transition={{ duration: 0.8 }}
        className="w-full max-w-2xl mx-auto mt-8 p-6 glass-card rounded-xl hover-scale"
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={currentKing as string}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col items-center space-y-4"
          >
            <div className="flex items-center space-x-2">
              <Crown className="h-6 w-6 text-yellow-500 animate-bounce" />
              <h2 className="text-xl font-bold">King of the Bots</h2>
            </div>
            
            <div className="text-center">
              <p className="text-lg">
                Current King:{" "}
                <span className="font-mono text-primary">
                  {currentKing ? formatAddress(currentKing) : "No King Yet"}
                </span>
              </p>
              <p className="text-sm text-muted-foreground">
                Current Stake:{" "}
                <span className="text-primary">
                  {currentStake ? formatEther(currentStake) : "0"} MATIC
                </span>
              </p>
            </div>

            <p className="text-sm text-muted-foreground">
              Click to view details and claim the throne
            </p>
          </motion.div>
        </AnimatePresence>
      </motion.div>
    </Link>
  );
};
